export const setBuildingPermitModals = (payload) => {
  return { type: "SET_BUILDING_PERMIT_MODALS", payload };
};
